<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="6" y="2.6" width="8" height="14.8" rx="2"/><path d="M8.8 14.9h2.4"/></svg>
</template>
